import { ProductType, SubscriptionType } from "./Product";

export enum PurchaseSource {
  PURCHASE = "purchase", // new purchase
  UPGRADE = "upgrade", // upgrade from individual
  SUBSCRIPTION_UPGRADE = "subscription_upgrade", // upgrade team
}

export enum VersionControl {
  VERSION_00 = "v00",
  VERSION_0 = "v0",
  VERSION_1 = "v1",
  VERSION_2 = "v2",
  VERSION_3 = "v3",
  VERSION_4 = "v4",
}

export type ILayoutInputFieldSchema = {
  name: string;
  label: string;
  isRequired: boolean;
};

export type ILayoutInputField = ILayoutInputFieldSchema & {
  value: string;
  error: string | null;
};

export type CheckoutItem =
  | PlanCheckoutItem
  | CardCheckoutItem
  | ShippingMethodCheckoutItem
  | CreditCheckoutItem;

export interface PlanCheckoutItem {
  type: ProductType.LITE | ProductType.SUBSCRIPTION;
  price_id: string;
  product_id: string;
  quantity: number;
  subscription_type: SubscriptionType;
  trial_days?: number;
}

export interface CardCheckoutItem {
  type: ProductType.CARD;
  price_id: string;
  product_id: string;
  quantity: number;
  layout: string;
  style: string;
  design_flag: string;
  design_brief?: string;
  logos?: string[];
  layoutInputValues?: ILayoutInputField[];
}

export interface ShippingMethodCheckoutItem {
  type: ProductType.SHIPPING;
  price_id: string;
  product_id: string;
  quantity: 1;
}

export interface CreditCheckoutItem {
  type: ProductType.CREDIT;
  price_id: string;
  product_id: string;
  quantity: number;
}

export interface CreateCheckoutSessionMetadataBody {
  source: PurchaseSource;
  version: VersionControl;
  team_id?: number;
  irclickid?: string;
}

export interface CreateCheckoutSessionBody {
  items: CheckoutItem[];
  trial_days?: string | number;
  success_url: string;
  cancel_url: string;
  metadata: CreateCheckoutSessionMetadataBody;
  currency_code: string;
  email?: string;
  event_properties?: any;
}

export interface CreateCheckoutSessionResponse {
  url: string;
}
